<template>
  <div class="col-md-12 d-flex profile-card">
    <div class="card card-table flex-fill card-details person-info">
      <div class="person-profile">
        <h4>Company Image</h4>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <div class="company-content">
            <h6>Company Logo</h6>
            <p>Upload Logo of your Company to display in website</p>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="company-content">
            <div class="profile-upload">
              <span
                ><img src="@/assets/admin_img/icon/upload.svg" class="img-fluid" alt="Upload"
              /></span>
              Upload Photo
              <input type="file" />
            </div>
            <p>For better preview recommended size is 450px x 450px. Max size 5MB.</p>
          </div>
        </div>
        <div class="col-md-3 col-12 logo-cont">
          <div class="company-content">
            <div class="logo-content logo-space">
              <img src="@/assets/admin_img/logo-dark.png" class="img-fluid" alt="Logo" />
              <div class="logo-delete">
                <a href="javascript:;">
                  <i class="bx bx-trash"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="company-content">
            <h6>Company Icon</h6>
            <p>Upload Logo of your Company to display in website</p>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="company-content">
            <div class="profile-upload">
              <span
                ><img src="@/assets/admin_img/icon/upload.svg" class="img-fluid" alt="Upload"
              /></span>
              Upload Photo
              <input type="file" />
            </div>
            <p>For better preview recommended size is 450px x 450px. Max size 5MB.</p>
          </div>
        </div>
        <div class="col-md-3 col-12">
          <div class="company-content d-flex justify-content-end">
            <div class="logo-content upload-space">
              <i class="bx bx-camera"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="company-content">
            <h6>Favicon</h6>
            <p>Upload Logo of your Company to display in website</p>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="company-content">
            <div class="profile-upload">
              <span
                ><img src="@/assets/admin_img/icon/upload.svg" class="img-fluid" alt="Upload"
              /></span>
              Upload Photo
              <input type="file" />
            </div>
            <p>For better preview recommended size is 450px x 450px. Max size 5MB.</p>
          </div>
        </div>
        <div class="col-md-3 col-12 logo-cont">
          <div class="company-content d-flex justify-content-end">
            <div class="logo-content upload-space">
              <img
                src="@/assets/admin_img/icon/logo-website.svg"
                class="img-fluid"
                alt="Logo"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="company-content">
            <h6>Company Dark Logo</h6>
            <p>Upload Logo of your Company to display in website</p>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="company-content">
            <div class="profile-upload">
              <span
                ><img src="@/assets/admin_img/icon/upload.svg" class="img-fluid" alt="Upload"
              /></span>
              Upload Photo
              <input type="file" />
            </div>
            <p>For better preview recommended size is 450px x 450px. Max size 5MB.</p>
          </div>
        </div>
        <div class="col-md-3 col-12">
          <div class="company-content">
            <div class="logo-content logo-space bg-logo">
              <img src="@/assets/admin_img/logo.png" class="img-fluid" alt="Logo" />
              <div class="logo-delete">
                <a href="javascript:;">
                  <i class="bx bx-trash"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
